import { InputLabel, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'

import ModalActionContainer from 'components/containers/modalActionContainer'
import { helper } from 'helper'
import FavoriteWorkForm from 'pages/security/components/favoriteWorkForm'
import FixedShiftsForm from 'pages/security/components/fixedShfitsForm'
import { Security } from 'types/security'
import {
  Cls1SecurityDetail,
  Cls2SecurityDetail,
  FavoriteWork,
  FixShift,
} from 'types/securityDetail'

interface Props {
  onCancel: () => void
  onAdd: (data: {
    security: Omit<Security, 'id'>
    cls1Detail: Cls1SecurityDetail
    cls2Detail: Cls2SecurityDetail
  }) => void
  onUpdate: (data: {
    security: Security
    cls1Detail: Cls1SecurityDetail
    cls2Detail: Cls2SecurityDetail
  }) => void
  defaultValue?: Form & {
    id: string
  }
}

interface Form {
  firstName: string
  lastName: string
  code: string
  email: string
  phone: string
  favoriteWork: Set<FavoriteWork>
  maxRepeatedly: number | ''
  fixShiftDays: FixShift[]
}

export default function SecurityRegisterModal(props: Props) {
  const { control, handleSubmit } = useForm<Form>({
    defaultValues: props.defaultValue ?? {
      firstName: '',
      lastName: '',
      code: '',
      email: '',
      phone: '',
      favoriteWork: new Set(),
      maxRepeatedly: '',
      fixShiftDays: [],
    },
  })
  const getControl = helper.control.valid(control)

  const formToData = (formValue: Form) => {
    const value = {
      security: {
        firstName: formValue.firstName,
        lastName: formValue.lastName,
        originalCode: formValue.code,
      },
      cls1Detail: {
        favoriteWork: Array.from(formValue.favoriteWork),
        maxRepeatedly:
          // formから文字列が返却されるので、数値に変換する
          formValue.maxRepeatedly === ''
            ? undefined
            : parseInt(formValue.maxRepeatedly.toString()),
        fixShiftDays: formValue.fixShiftDays,
      },
      cls2Detail: {
        email: formValue.email,
        phoneNumber1: formValue.phone,
      },
    }
    if (props.defaultValue == null) {
      props.onAdd(value)
    } else {
      props.onUpdate({
        security: {
          ...value.security,
          id: props.defaultValue.id,
        },
        cls1Detail: value.cls1Detail,
        cls2Detail: value.cls2Detail,
      })
    }
  }

  return (
    <form onSubmit={handleSubmit(formToData)}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <InputLabel>性</InputLabel>
          <Controller
            {...getControl('lastName').c}
            render={({ field }) => (
              <TextField required {...field} size="small" fullWidth={true} />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel>名</InputLabel>
          <Controller
            {...getControl('firstName').c}
            render={({ field }) => (
              <TextField required {...field} size="small" fullWidth={true} />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <InputLabel>隊員番号</InputLabel>
          <Controller
            {...getControl('code').c}
            render={({ field }) => (
              <TextField {...field} size="small" fullWidth={true} />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          {/* blank */}
        </Grid>

        <Grid item xs={6}>
          <InputLabel>電話番号</InputLabel>
          <Controller
            {...getControl('phone').c}
            render={({ field }) => (
              <TextField {...field} size="small" fullWidth={true} />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <InputLabel>メールアドレス</InputLabel>
          <Controller
            {...getControl('email').c}
            render={({ field }) => (
              <TextField {...field} size="small" fullWidth={true} />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel>希望勤務</InputLabel>
          <FavoriteWorkForm {...getControl('favoriteWork')} />
        </Grid>

        <Grid item xs={3}>
          <InputLabel>最大連勤</InputLabel>
          <Controller
            {...getControl('maxRepeatedly').c}
            render={({ field }) => (
              <TextField
                type="number"
                {...field}
                size="small"
                fullWidth={true}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel>出勤曜日固定</InputLabel>
          <FixedShiftsForm {...getControl('fixShiftDays')} />
        </Grid>
      </Grid>
      <ModalActionContainer>
        <Button variant="negative" onClick={props.onCancel}>
          キャンセル
        </Button>
        <Button variant="contained" type="submit">
          保存
        </Button>
      </ModalActionContainer>
    </form>
  )
}
